module.exports = __webpack_public_path__ + "img/Img_contact-us.304479f2.jpg";